<section global-hero class="sign-up-hero" [heroData]="heroData"></section>
<section knowledge-section></section>
<section form></section>